import React from "react";
import {observer} from "mobx-react-lite";
import BrandBanner from "../brandBanner/BrandBanner";
import ListHeader from "./listHeader/ListHeader";
import BrandSelect from "../elements/brand/BrandSelect";
import DataTable from 'react-data-table-component'
import "./ListView.css";
import {Input} from "reactstrap";

const columns = [
    {
        cell: (props) => (
            <a
                style={{textDecoration: "none", fontSize: 14, fontFamily: 'Lato', color: "#000"}}
                href={props.url}

            >
                {props.label}
            </a>
        ),
        ignoreRowClick: true,
        wrap: true,
        allowOverflow: true,
    },
];
const tableCustomStyles = {
    rows: {
        padding: "0px",
        stripedStyle: {
            backgroundColor: "#f4f4f4"
        }
    }
}

const ListView = observer(({store}) => {
    return (
        <>
            {store.brandImage && <BrandBanner store={store}/>}
            <ListHeader/>
            <div className="search_bars">
                <div></div>
                <div>

                    <label className="brand_title title"  id="brand-label" >Brand: </label>
                    <BrandSelect store={store.brandSelectState}/>
                </div>
                <div></div>

                <div>
                    <div className="search_title title">Product:</div>
                    <Input
                        className="search_input"
                        type="text"
                        name="searchInput"
                        placeholder="All"
                        value={store.searchInput}
                        onChange={store.handleSearchChange}
                    />
                </div>
                <div></div>
                <button onClick={store.handleSubmit}> SUBMIT</button>
            </div>
            <div className="list">
                <div className="data_header">PRODUCT</div>
                <div className="table_container">
                    { <DataTable
                        columns={columns}
                        data={store.items}
                        progressPending={store?.isLoading}
                        striped
                        pagination
                        paginationServer
                        paginationTotalRows={store?.totalRows}
                        paginationRowsPerPageOptions={[10,25,50,100]}
                        onChangeRowsPerPage={store.handlePerRowsChange}
                        noTableHead={true}
                        customStyles={tableCustomStyles}
                        onChangePage={store.handlePageUpdate}
                    />}
                </div>
            </div>
        </>
    )
})

export default ListView;
